"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    divider_indent_inset: index_scss_1.default.divider_indent_inset,
    divider_indent_middle_horizontal: index_scss_1.default.divider_indent_middle_horizontal,
    divider_indent_middle_vertical: index_scss_1.default.divider_indent_middle_vertical,
    divider_padding_bottom: index_scss_1.default.divider_padding_bottom,
    divider_padding_left: index_scss_1.default.divider_padding_left,
    divider_padding_right: index_scss_1.default.divider_padding_right,
    divider_padding_top: index_scss_1.default.divider_padding_top,
    divider_size_bold: index_scss_1.default.divider_size_bold,
    divider_size_medium: index_scss_1.default.divider_size_medium,
    divider_size_thin: index_scss_1.default.divider_size_thin,
    divider_text_align_indent: index_scss_1.default.divider_text_align_indent,
    divider_text_indent: index_scss_1.default.divider_text_indent,
};
